import { useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';
import { Link } from '@mui/material';

interface PrimaryUnderlinedLinkProps {
  navigateTo: string;
  text: string;
}

const PrimaryUnderlinedLink: React.FC<PrimaryUnderlinedLinkProps> = ({ navigateTo, text }) => {
  const navigate = useNavigate();
  const { theme } = useThemeContext();

  return (
    <Link
      onClick={() => navigate(navigateTo)}
      sx={{
        '&:hover': { cursor: 'pointer' },
        color: theme.custom.pages.userLogin.typography.links.color,
        textDecorationColor: theme.custom.pages.userLogin.typography.links.color,
      }}
    >
      {text}
    </Link>
  );
};

export default PrimaryUnderlinedLink;
